import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

import { NgRedux } from '@angular-redux/store';
import { TranslateService } from '@ngx-translate/core';

import { ApplicationFacade, NotificationFacade, ShoppingCartFacade, TicketsService } from '@ridango/components';
import {
    LogService,
    UserTicketAction,
    UserTicketActionsEnum,
    UserTicketActionCarrier,
    AppStartupService
} from '@ridango/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-cart-tickets',
    templateUrl: './cart-tickets.component.html'
})
export class CartTicketsComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    cart$ = this.cartFacade.cart$;
    allDocNums$ = this.cartFacade.docNums$;
    groupedTicketsByProduct$ = this.cartFacade.groupedTicketsByProduct$;
    assetsPath$ = this.applicationFacade.assetsPath$;

    cart: any;
    locale = 'en'; // default, will be overwritten in ngOnInit

    useInputActions = true;
    ticketActions: UserTicketAction[] = [];
    ticketDeleteModalVisible = false;
    ticketToDelete;
    isVoucher = false;
    voucherEmail = '';
    transportDayEndPrevDate = false;

    constructor(
        @Inject('ENV') public env: any,
        private cartFacade: ShoppingCartFacade,
        private applicationFacade: ApplicationFacade,
        private ngRedux: NgRedux<any>,
        private notification: NotificationFacade,
        private ls: LogService,
        private translate: TranslateService,
        public appStartupService: AppStartupService
    ) {}

    ngOnInit() {
        this.locale = this.translate.currentLang;

        this.transportDayEndPrevDate = this.env.TRANSPORT_DAY_END_PREV_DAY
            ? this.env.TRANSPORT_DAY_END_PREV_DAY
            : false;

        this.cart$.pipe(takeUntil(this.componentDestroyed$)).subscribe((c) => {
            if (c) {
                if (c.shopping_cart_id && c.docNums.length === 0) {
                    this.cartFacade.deleteCart();
                    this.notification.removeAll();
                }

                this.cart = c;
                this.cart.docNums.map((dn) => {
                    const t = this.ngRedux.getState().cart.tickets[dn];
                    if (c.status === 'L') {
                        this.ticketActions = [];
                    } else if (!this.env.IS_CORPORATE) {
                        this.ticketActions = [new UserTicketAction(UserTicketActionsEnum.DELETE)];
                    }
                    return t;
                });

                if (!c.tickets || c.tickets.length === 0) {
                    this.notification.removeAll();
                }
            }
        });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    ticketAction(action: UserTicketActionCarrier) {
        this.ls.log(this, 'ticketAction', action);
        switch (action.action.type) {
            case UserTicketActionsEnum.DELETE:
                this.deleteTicketAction(action.ticket);
                return;
        }
    }

    deleteTicketAction(ticket: any) {
        this.cartFacade.deleteTicketFromCart(ticket, this.cart);
    }

    getProductTypeByDocNum(dn) {
        return this.ngRedux
            .getState()
            .cart.ticketsGroupedUids.map((uid) => {
                return this.ngRedux.getState().cart.ticketsGrouped[uid];
            })
            .filter((ticket) => {
                return ticket.docNums.indexOf(dn) >= 0;
            })
            .reduce((acc, ticket) => {
                return ticket.product_object.product_type;
            }, null);
    }

    removeCard(docNum) {
        this.deleteTicketAction(this.cart.ticketsByDocNum[docNum]);
    }
}
